<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <!-- navegación -->
    <div class="tabs">
      <div :class="{ circle: true, circle_active: 0 <= index_tab }">
        <v-icon dark v-if="index_tab > 0 && readonly == false" @click="selectedTab(0)">fa fa-pencil-alt</v-icon>
        <v-icon dark v-else-if="index_tab > 0 && readonly == true" @click="selectedTab(0)">far fa-eye</v-icon>
        <span v-else>1</span>
      </div>
      <div class="titulo">Principal</div>
      <div class="separador"></div>
      <div :class="{ circle: true, circle_active: 1 <= index_tab }">2</div>
      <div class="titulo">Domicilio</div>
    </div>
    <!-- card de registro familiar -->
    <v-card class="mb-8">
      <!-- <v-card-title class="btn_agregar py-2" >
                    <v-row class="d-flex justify-center py-0">
                        <h3>{{tituloSelected}}</h3>
                    </v-row> 
            </v-card-title> -->
      <v-card-text v-show="index_tab === 0">
        <v-container>
          <v-form ref="form_alumno_datos_personales">
            <v-container>
              <v-alert dark class="btn_agregar d-flex justify-center">
                <h3>{{ tituloSelected }}</h3>
              </v-alert>
              <v-row>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Nombres" v-model="nombres" :rules="validationRules.validateName"
                    :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Apellido paterno" v-model="apellidoPaterno" type="text"
                    :rules="validationRules.validateCampo" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Apellido materno" v-model="apellidoMaterno" type="text"
                    :rules="validationRules.validateCampo" :readonly="readonly" />
                </v-col>
                <v-col cols="12" sm="12" md="3" class="d-flex justify-center order-first order-md-0">
                  <template>
                    <!-- Cuando se seleccione una imagen se mostrará esa  -->
                    <v-avatar size="116" hover @click="pickAvatar">
                      <img v-show="img" :src="srcImg" class="fondo_add_img" size="80" />
                      <!-- Si existe una foto en la BD y aun no se ha seleccionado una foto se mostrá la img guardada(en la BD)-->
                      <img v-show="previewAvatar && !img" :src="previewAvatar" class="fondo_add_img" size="80" />
                      <!-- Si no hay una imagen previa en la bd y aun no se ha seleccionado ninguna se mostrará un icono  -->
                      <v-icon v-show="!previewAvatar && !img" class="fondo_add_img" size="80">fas fa-user</v-icon>
                      <input type="file" style="display: none" ref="imageCol" accept=".jpg, .png"
                        @change="onFileAvatar" />
                    </v-avatar>
                  </template>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <AutocompleteComp textLabel="Tipo de documento de identidad"
                    @change="changedinamicValidation(idTipoDocumento)" :items="listTipoDocumentos"
                    v-model="idTipoDocumento" :rules="validationRules.validateCampo" item-text="desc_tipo_documento"
                    item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Número de documento de identidad" :append-icon="'fa-search'"
                    v-model="numeroDocumento" :rules="dinamicValidation" :readonly="readonly" :disabled="perfilEdit"
                    @click:append="buscarPersona()" @blur="buscarPersona()" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <AutocompleteComp textLabel="Sexo" @change="seleccionarSexo(idSexo)" :items="listSexos"
                    v-model="idSexo" :rules="validationRules.validateCampo" item-text="descripcion" item-value="id"
                    :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition"
                    offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fechaNacimientoFormateada" label="Fecha de nacimiento"
                        :rules="[(v) => !!v || 'Campo requerido']" @blur="
        fechaNacimiento = parseDate(fechaNacimientoFormateada)
        " v-bind="attrs" v-on="readonly ? false : on" :readonly="readonly" @keypress="($event) => {
          return $event.preventDefault();
        }
        "></v-text-field>
                    </template>
                    <v-date-picker v-model="fechaNacimiento" :max="moment().format()" @input="menu = false" no-title
                      scrollable :readonly="readonly">
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <AutocompleteComp textLabel="País de nacimiento" @change="seleccionarPaisNacimiento(idPaisNacimiento)"
                    :items="listPaises" v-model="idPaisNacimiento" :rules="validationRules.validateCampo"
                    item-text="nombre_pais" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <AutocompleteComp textLabel="Nacionalidad" @change="seleccionarNacionalidad(idNacionalidad)"
                    :items="listNacionalidades" v-model="idNacionalidad" :rules="validationRules.validateCampo"
                    item-text="desc_nacionalidad" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <AutocompleteComp textLabel="Religión" @change="seleccionarTipoReligion(idTipoReligion)"
                    :items="listTipoReligiones" v-model="idTipoReligion" :rules="validationRules.validateCampo"
                    item-text="desc_religion" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <AutocompleteComp textLabel="Discapacidad" @change="seleccionarTipoDiscapacidad(idTipoDiscapacidad)"
                    :items="listTipoDiscapacidades" v-model="idTipoDiscapacidad" :rules="validationRules.validateCampo"
                    item-text="desc_discapacidad" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Correo electrónico" v-model="correo" :rules="validationRules.validateCorreo"
                    :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Código del estudiante (SIAGIE)" v-model="cod_estudiante"
                    :rules="validationRules.validateCampo" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="12">
                  <textfieldComp textLabel="Observación" v-model="observacionAlumno" :readonly="readonly" />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-radio-group class="mt-0" v-model="estado_alumno" label="Estado">
                    <v-radio label="Activo" :value="1" color="teal"></v-radio>
                    <v-radio label="Inactivo" :value="0" color="error"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- DATOS DE USUARIO PARA EL ALUMNO -->
              <!-- CREDENCIALES DE USUARIO -->

              <v-row>
                <v-col cols="12" sm="12" md="12" class="pb-0">
                  <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                    <h3>CREDENCIALES DE USUARIO</h3>
                  </v-alert>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-text-field label="Nombre de usuario" type="text" v-model="persona.usu_usuario"
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3" class="py-0" v-if="this.evento == 'agregar'">
                  <v-text-field v-model="persona.password_usuario" :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                    :rules="validationRules.validatePassword" :type="show ? 'text' : 'password'" label="Contraseña"
                    @click:append="show = !show">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0" v-if="!habilitarUsMaster">
                  <v-autocomplete v-model="persona.id_perfil" :items="Perfil" item-text="descripcion_perfil"
                    item-value="id_perfil" @change="cargarLicenciaTipo(persona.id_perfil)"
                    :rules="validationRules.validateCampoList" label="Perfil" :disabled="perfilEdit" auto-select-first>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0" v-if="!habilitarUsMaster">
                  <v-select label="Tipo de licencia" v-model="persona.id_licencia_tipo" :items="LicenciaTipo"
                    item-value="id" item-text="desc_tipo_licencia" :readonly="persona.fecha_fin > new Date().toISOString().substr(0, 10)
        " disabled>
                  </v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0" v-if="persona.fecha_fin > new Date().toISOString().substr(0, 10)
        ">
                  Licencia
                  <p class="black--text">{{ persona.serie_licencia }}</p>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0" v-else>
                  <v-autocomplete label="Licencias" v-model="persona.id_licencia" :items="Licencia" item-value="id"
                    item-text="serie_licencia" disabled>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-text v-show="index_tab === 1">
        <v-container>
          <v-form ref="form_alumno_ubicacion">
            <v-alert dark class="btn_agregar d-flex justify-center">
              <h3>{{ tituloSelected }}</h3>
            </v-alert>
            <v-container>
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="País" @change="seleccionarPais(idPais)" :items="listPaises"
                    v-model="idPais" :rules="validationRules.validateCampo" item-text="nombre_pais" item-value="id"
                    :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Departamento" @change="seleccionarDepartamento(idDepartamento)"
                    :items="listDepartamentos" v-model="idDepartamento" :rules="validationRules.validateCampo"
                    item-text="nombre_ubicacion1" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Provincia" @change="seleccionarProvincia(idProvincia)"
                    :items="listProvincias" v-model="idProvincia" :rules="validationRules.validateCampo"
                    item-text="nombre_ubicacion2" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Distrito" :items="listDistritos" v-model="idDistrito"
                    :rules="validationRules.validateCampo" ref="refDistrito" item-text="nombre_ubicacion3"
                    item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <textfieldComp textLabel="Dirección" v-model="direccion" :rules="validationRules.validateCampo"
                    :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <textfieldComp textLabel="Teléfono móvil" v-model="celular" :readonly="readonly"
                    :rules="validationRules.validateMovilphone" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <textfieldComp textLabel="Teléfono fijo" :rules="validationRules.validatePhone" v-model="telefono"
                    :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="El estudiante vive con" :items="listViveCon" v-model="viveCon"
                    :rules="validationRules.validateCampo" item-text="name" item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6" v-if="viveCon === 'otros'">
                  <textfieldComp textLabel="Descripción Otros" v-model="descripcionOtros" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="12" sm="12">
                  <textfieldComp textArea textLabel="Observación" v-model="observacionDomicilio" :readonly="readonly" />
                </v-col>
              </v-row>
            </v-container>
            <v-alert dark class="btn_agregar d-flex justify-center py-2 px-0 mx-0">
              <!-- <h3>{{ tituloSelected }}</h3> -->
              <h3>NIVEL Y GRADO</h3>
            </v-alert>
            <v-container>
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <!-- El elemento de que usa el compoennete AutocompleteComp estaba comentado y en su lugar estaban usando v-autocomplete 
                      lo descomenté y comenté el de vutify para seguir el estandar en diseño, arentemente no se encuentran errores
                  -->

                  <AutocompleteComp textLabel="Nivel" @change="getAllGradosAdmin()" v-model="idNivel"
                    :items="listNivelesAdmin" :rules="validationRules.validateCampo" item-text="desc_nivel"
                    item-value="id" :readonly="readonly" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Grado" :items="listGradosAdmin" v-model="idGrado"
                    :rules="validationRules.validateCampo" item-text="desc_grado" item-value="id"
                    :readonly="readonly" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="btn_actions">
        <v-spacer></v-spacer>
        <v-row dense>
          <v-col cols="12" class="d-flex justify-end gap-10px">
            <TableButtonComp v-if="index_tab === 0" @click="tabNext" textButton="Continuar"
              iconBut="fas fa-arrow-circle-right" normalButton />

            <TableButtonComp v-if="index_tab === 1 && readonly === false" @click="save" :loading="loading"
              :textButton="tituloGuardar" iconBut="fas fa-save" normalButton />

            <TableButtonComp v-if="index_tab === 1" @click="tabBack" textButton="Volver" classColor="red"
              iconBut="fas fa-arrow-circle-left" normalButton />

            <TableButtonComp v-if="index_tab === 0" @click="cancelar" textButton="Cancelar" classColor="red"
              normalButton />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <ComunDialogCompVue Confirmdialog titleWindow="Confirmación" v-model="modal_edit_nivel_grado"
      @close-modal="modal_edit_nivel_grado = false" @confirm-item="editarEstudianteNivelGrado"
      @cancel-item="modal_edit_nivel_grado = false">
      <template v-slot:body>
        <h3>
          ¿Está seguro de que desea modificar el nivel o grado del estudiante?
          Al hacerlo se eliminará toda la información del estudiante asociada a
          la sección actual.
        </h3>
      </template>
    </ComunDialogCompVue>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import TableButtonComp from "@/components/ComponentsEst/TableButtonComp.vue";
import textfieldComp from "@/components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import { validationRules } from "@/helpers/validatorHelpers.js";
import ComunDialogCompVue from '../../../components/ComponentsEst/ComunDialogComp.vue';

import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import moment from "moment";

export default {
  components: {
    textfieldComp,
    ComunDialogCompVue,
    AutocompleteComp,
    TableButtonComp,
  },

  data() {
    return {
      datoLogin: sessionStorage,
      readonly: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      index_tab: 0,
      titulos: ["DATOS PERSONALES", "DATOS DE UBICACIÓN"],
      tituloGuardar: "",
      tituloSelected: "",
      dinamicValidation: [],
      loading: false,
      idAlumno: 0,
      idColegio: parseInt(sessionStorage.getItem("id_colegio")),
      idUsuario: parseInt(sessionStorage.getItem("id")),
      idPaisUser: parseInt(sessionStorage.getItem("id_pais")),

      listTipoDocumentos: [],
      listSexos: [
        { id: "M", descripcion: "Masculino" },
        { id: "F", descripcion: "Femenino" },
      ],
      listPaises: [],
      listTipoReligiones: [],
      listTipoDiscapacidades: [],
      listNacionalidades: [],
      listDepartamentos: [],
      listProvincias: [],
      listDistritos: [],
      defaultPais: 145,

      /**alumnos datos personales */
      idTipoDocumento: "",
      idSexo: "",
      idPaisNacimiento: "",
      idTipoReligion: "",
      idTipoDiscapacidad: "",
      idNacionalidad: "",
      observacionAlumno: "",
      correo: "",
      cod_estudiante: "",
      fechaNacimiento: new Date().toISOString().substr(0, 10),
      fechaNacimientoFormateada: "",
      numeroDocumento: "",
      nombres: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      avatar_persona: "",
      ruta_avatar_persona: null,
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      estado_alumno: 0,

      /**alumnos datos de ubicación*/
      idPais: "",
      idDepartamento: "",
      idProvincia: "",
      idDistrito: "",
      direccion: "",
      celular: "",
      telefono: "",
      observacionDomicilio: "",
      viveCon: "",
      listViveCon: [
        { id: "papa", name: "Papá" },
        { id: "mama", name: "Mamá" },
        { id: "ambos", name: "Ambos" },
        { id: "otros", name: "Otros" },
      ],
      idNivel: "",
      idGrado: "",
      descripcionOtros: "",


      //  AVATAR DEL ALUMNO
      img: null,
      srcImg: null,
      previewAvatar: null,

      rutaServer: `${API_URL}`,



      nivelParams: {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio_adm_nivel: sessionStorage.id_colegio,
      },

      listNivelesAdmin: [],
      listGradosAdmin: [],

      //Modal y variables de confirmación en caso quiera editar el nivel y/o grado de un estudiante, el cual ya ha tenido clases y evaluaciones en otro nivel y/o grado
      nivel_before: "",
      grado_before: "",
      modal_edit_nivel_grado: false,

      //Variables de credenciales de usuario
      evento: "",
      item: {},
      persona: {},
      show: false,
      password_usuario: "",
      habilitarUsMaster: false,
      Perfil: [],
      TipoDocumentos: [],
      Colegio: [],
      Paises: [],
      Ubicacion1: [],
      perfilFiltered: {},
      userParams: {},
      perfilEdit: false,
      LicenciaTipo: [],
      id_licencia: 0,
      Licencia: [],
    };
  },
  created() {
    this.evento = this.$route.query.evento;
    this.evento2 = this.$route.params.evento;
    this.item = this.$route.query.alumno ? this.$route.query.alumno : this.$route.params;
  },

  mounted() {
    this.tituloSelected = this.titulos[this.index_tab];
    //cargamos la información principal que se usará en el formulario
    this.loadMain();

    setTimeout(() => {
      this.dataInitial();
    }, 1000);
  },
  watch: {
    fechaNacimiento() {
      this.fechaNacimientoFormateada = this.formatDate(this.fechaNacimiento);
    },
    numeroDocumento(newValue) {

      if (this.evento == 'agregar') {
        this.persona.usu_usuario = "";
        this.persona.usu_usuario = `${newValue}-${this.datoLogin.id_colegio}-${this.persona.usu_usuario}`
        this.persona.password_usuario = `${newValue}`
        this.persona.id_perfil = "";
      }
    },
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    parseDate(dateFormated) {
      if (!dateFormated) return null;
      const [day, month, year] = dateFormated.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    tabNext() {
      if (this.$refs.form_alumno_datos_personales.validate()) {
        this.index_tab++;
        this.tituloSelected = this.titulos[this.index_tab];
      }
    },
    tabBack() {
      if (this.index_tab > 0) {
        this.index_tab--;
        this.tituloSelected = this.titulos[this.index_tab];
      }
    },
    selectedTab(index) {
      this.index_tab = index;
      this.tituloSelected = this.titulos[this.index_tab];
    },


    changedinamicValidation(id) {
      switch (id) {
        case 1:
          this.dinamicValidation = validationRules.validateDni
          break;
        case 2:
          this.dinamicValidation = validationRules.validateDocument
          break;
        case 4:
          this.dinamicValidation = validationRules.validateRuc
          break;

        default:
          break;
      }
    },

    validarTelefono(e) {
      let keyCode = e.keyCode;
      let digito = e.key;
      if (
        isNaN(digito) &&
        keyCode !== 187 &&
        keyCode !== 8 &&
        keyCode !== 37 &&
        keyCode !== 39
      ) {
        return e.preventDefault();
      }
      return true;
    },
    validarSoloNumero($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    validarSoloTexto($event) {
      let regex = new RegExp("^[a-zA-Z ]+$");
      let key = String.fromCharCode(
        !$event.charCode ? $event.which : $event.charCode
      );
      if (!regex.test(key)) {
        $event.preventDefault();
        return false;
      }
    },
    cancelar() {
      this.$router.push("/registroacademico");
    },
    guardarFecha(date) {
      this.$refs.menu.save(date);
    },
    dataInitial() {
      this.getTipoDocumentos();
      this.getPaises();
      this.getTipoReligiones();
      this.getTipoDiscapacidades();
      this.getAllNivelesAdmin();

      this.idPais = this.defaultPais;
      this.seleccionarPais(this.idPais);
      if (parseInt(this.$route.params.id) > 0) {
        this.cargarAlumno(parseInt(this.$route.params.id));
        this.tituloGuardar = "Guardar Cambios";
      } else {
        this.tituloGuardar = "Guardar";
      }

      if (parseInt(this.$route.params.editarAlumno) == 0) {
        this.readonly = true;
      } else {
        this.readonly = false;
      }
    },

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      this.limpiarForm();
      // this.filterPerfilByTipoPersonal()
      if (this.evento == "agregar") {
        this.perfilEdit = false;
        this.persona.id_persona = 0;
        this.persona.id = 0;
      }
      // const numdocLength = String(this.persona.numdoc_persona).length;

      // if (numdocLength >= 8 && numdocLength < 9) {
      //   this.persona.id_tipo_documento = 1;
      // } else if (numdocLength >= 9) {
      //   this.persona.id_tipo_documento = 2;
      // }

      if (this.evento == "editar" || this.evento2 == "ver") {
        this.perfilEdit = true;
        this.getUserCredentialData()
      }

      this.getQueryUsers()
    },

    async limpiarForm() {
      this.persona = {
        id_usuario: this.datoLogin.id,
        id_colegio: this.datoLogin.id_colegio,
        id_pais: this.defaultPais,
        ruta_avatar_persona: null,
        avatar_persona: null,
        ape2_persona: null,
        direc_persona: null,
        correo_persona: null,
        telf_persona: null,
        cel_persona: null,
        evento: null,
        evento2: null,
        estado_persona: 0,
        estado_usuario: 1,
        id_tipo_usuario: null,
      };
    },
    async cargarAlumno(idAlumno) {
      try {
        //traemos los datos del alumno
        this.idAlumno = idAlumno;

        let response = await axios.post("/administrativo/alumno/getAlumno", {
          idColegio: this.idColegio,
          idAlumno: this.idAlumno,
        });

        response = response.data;

        if (response.messageT === "S") {
          let alumno = response.payload;

          this.nombres = alumno.persona.nombre_persona;
          this.apellidoPaterno = alumno.persona.ape1_persona;
          this.apellidoMaterno = alumno.persona.ape2_persona;
          this.idTipoDocumento = alumno.persona.id_tipo_documento;
          this.numeroDocumento = alumno.persona.numdoc_persona;
          this.idSexo = alumno.persona.sexo_persona;
          this.fechaNacimiento = alumno.persona.fecnac_persona;
          this.idPaisNacimiento = alumno.persona.id_pais_nacimiento;
          this.idNacionalidad = alumno.persona.id_nacionalidad;
          this.idTipoReligion = alumno.id_religion;
          this.idTipoDiscapacidad = alumno.id_discapacidad;
          this.correo = alumno.persona.correo_persona;
          this.observacionAlumno = alumno.observacion_alumno;
          this.idPais = alumno.persona.id_pais;
          this.idDepartamento = alumno.persona.id_ubicacion1;
          this.idProvincia = alumno.persona.id_ubicacion2;
          this.idDistrito = alumno.persona.id_ubicacion3;
          this.direccion = alumno.persona.direc_persona;
          this.observacionDomicilio = alumno.persona.observacion_domicilio;
          this.celular = alumno.persona.cel_persona;
          this.telefono = alumno.persona.telf_persona;
          this.viveCon = alumno.vive_con;
          this.cod_estudiante = alumno.cod_estudiante;
          this.estado_alumno = alumno.estado_alumno;
          if (this.viveCon === "otros") {
            this.descripcionOtros = alumno.vive_con_descripcion;
          }
          this.avatar_persona = alumno.persona.avatar_persona;
          this.ruta_avatar_persona = alumno.persona.ruta_avatar_persona;
          this.idNivel = alumno.id_nivel;
          this.nivel_before = alumno.id_nivel;
          this.idGrado = alumno.id_grado;
          this.grado_before = alumno.id_grado;
          this.getNacionalidades();
          this.getDepartamentos();
          this.getProvincias();
          this.getDistritos();
          this.getAllNivelesAdmin();

          // Funcion para traer su img previa (si existe)
          this.get_avatar();

        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `No se pudo cargar datos del alumno`,
            tiempo: null,
          });
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar datos del alumno`,
          tiempo: null,
        });
      }
    },

    async buscarPersona() {
      if (this.numeroDocumento === "") {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Debe de ingresar un número de documento.",
          tiempo: null,
        });
      } else {
        let response = await axios.post(
          "/administrativo/alumno/validarEstudiante",
          {
            idColegio: this.idColegio,
            numeroDocumento: this.numeroDocumento,
          }
        );

        //Cuando el documento no se encuetra registrado entra aqui
        if (response.data.messageT == "W") {
          //Cuando el documento ya se encuetra asociado a un perfil "estudiante" limpia el campo del formulario
          if (response.data.payload == 1) {
            this.numeroDocumento = ""
            this.setEnviarMens({
              tipo: "W",
              mensaje: response.data.message,
              tiempo: null,
            });
          }
          return
        }

        if (response.data.messageT == "S") {

          this.setEnviarMens({
            tipo: "W",
            mensaje: response.data.message,
            tiempo: null,
          });

          this.numeroDocumento = ""
        }
      }
    },

    async getTipoDocumentos() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoDocumentos",
          {
            idColegio: this.idColegio,
            idPais: this.idPaisUser,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listTipoDocumentos = response.payload;
        }
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de documentos`,
          tiempo: null,
        });
      }
    },

    async getPaises() {
      try {
        let response = await axios.post("/administrativo/alumno/getPaises", {
          idColegio: this.idColegio,
        });

        response = response.data;

        if (response.messageT === "S") {
          this.listPaises = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de países`,
          tiempo: null,
        });
      }
    },
    async getTipoReligiones() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoReligiones",
          {
            idColegio: this.idColegio,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listTipoReligiones = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de religiones`,
          tiempo: null,
        });
      }
    },
    async getTipoDiscapacidades() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoDiscapacidades",
          {
            idColegio: this.idColegio,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listTipoDiscapacidades = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de discapacidades`,
          tiempo: null,
        });
      }
    },
    async getNacionalidades() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getNacionalidades",
          {
            idColegio: this.idColegio,
            idPais: this.idPaisNacimiento,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listNacionalidades = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de nacionalidades`,
          tiempo: null,
        });
      }
    },
    async getDepartamentos() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getDepartamentos",
          {
            idColegio: this.idColegio,
            idPais: this.idPais,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listDepartamentos = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de departamentos`,
          tiempo: null,
        });
      }
    },
    async getProvincias() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getProvincias",
          {
            idColegio: this.idColegio,
            idPais: this.idPais,
            idDepartamento: this.idDepartamento,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listProvincias = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de provincias`,
          tiempo: null,
        });
      }
    },
    async getDistritos() {
      try {
        let response = await axios.post("/administrativo/alumno/getDistritos", {
          idColegio: this.idColegio,
          idPais: this.idPais,
          idDepartamento: this.idDepartamento,
          idProvincia: this.idProvincia,
        });

        response = response.data;

        if (response.messageT === "S") {
          this.listDistritos = response.payload;
        }
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de distrito`,
          tiempo: null,
        });
      }
    },

    /**eventos */
    seleccionarTipoDocumento(idTipoDocumento) {
      this.idTipoDocumento = idTipoDocumento;
      this.$refs.refNumeroDocumento.validate();
    },
    seleccionarSexo(idSexo) {
      this.idSexo = idSexo;
    },
    seleccionarPaisNacimiento(idPaisNacimiento) {
      this.idPaisNacimiento = idPaisNacimiento;
      this.getNacionalidades();
    },
    seleccionarTipoReligion(idTipoReligion) {
      this.idTipoReligion = idTipoReligion;
    },
    seleccionarTipoDiscapacidad(idTipoDiscapacidad) {
      this.idTipoDiscapacidad = idTipoDiscapacidad;
    },
    seleccionarNacionalidad(idNacionalidad) {
      this.idNacionalidad = idNacionalidad;
    },
    seleccionarPais(idPais) {
      this.idPais = idPais;
      this.getDepartamentos();
    },
    seleccionarDepartamento(idDepartamento) {
      this.idDepartamento = idDepartamento;
      this.getProvincias();
    },
    seleccionarProvincia(idProvincia) {
      this.idProvincia = idProvincia;
      this.getDistritos();
    },
    seleccionarDistrito(idDistrito) {
      this.idDistrito = idDistrito;
    },


    //////////// Registro de Usuario ////////////////////
    ///////// Evento --> Crear /////////////
    async getQueryUsers() {
      try {
        let response = await axios.get(
          "/sistema/usuario/getQuery/" + this.datoLogin.id_colegio
        );

        this.Colegio = response.data.colegio;
        this.TipoDocumentos = response.data.tipoDocumento;
        // this.Perfil = response.data.perfil;
        let filterPerfil = response.data.rolPerfil.filter(e => ["estudiante"].includes(e.desc_rol_licencia));

        this.Perfil = filterPerfil;
        this.Paises = response.data.pais;
        this.Ubicacion1 = response.data.ubicacion1;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async cargarLicenciaTipo(perfil) {

      try {
        this.persona.id_licencia = 0;

        if (!perfil) {
          throw new Error('No se han asignado licencias para el tipo de personal o perfil seleccionado')
        }

        let params = `/sistema/usuario/perfilLicenciaTipo/colegio/${this.datoLogin.id_colegio}/perfil/${perfil}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);

        if (!response.data || response.data.length == 0) {
          throw new Error("No se ha asignado ningun tipo de licencia a este perfil");
        }

        this.LicenciaTipo = response.data;

        if (this.evento == 'agregar') {

          this.persona.id_licencia_tipo = this.LicenciaTipo[0].id_licencia_tipo
          this.persona.usu_usuario = `${this.numeroDocumento}-${this.datoLogin.id_colegio}-${this.persona.id_perfil}`

          await this.cargarLicencia()
        }

      } catch (error) {
        if (error.response) {
          // Si es una respuesta de axios, mostrará información adicional sobre el error
          this.setEnviarMens({ tipo: "E", mensaje: `Error de red: ${error.message}`, tiempo: null });
        } else {
          // Si es una excepción genérica
          this.setEnviarMens({ tipo: "E", mensaje: `${error.message}`, tiempo: null });
        }

        // Lanzar la excepción nuevamente para que otros controladores de errores superiores puedan manejarla si es necesario
        throw error;
      }
    },

    async cargarLicencia() {

      try {

        let params = `/sistema/usuario/licenciaDisponibles/licenciaTipo/${this.persona.id_licencia_tipo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);


        if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
          // Si la respuesta no contiene datos o no es un arreglo o está vacío,
          // lanzar una excepción
          this.persona.id_perfil = ""
          this.persona.id_licencia_tipo = ""

          this.$forceUpdate();
          throw new Error('No se encontraron licencias disponibles para este perfil.');
        }

        // Asignar la primera licencia disponible
        this.Licencia = response.data;
        this.persona.id_licencia = this.Licencia[0].id

      } catch (error) {

        if (error.response) {
          // Si es una respuesta de axios, mostrará información adicional sobre el error
          this.setEnviarMens({ tipo: "E", mensaje: `Error de red: ${error.message}`, tiempo: null });
        } else {
          // Si es una excepción genérica
          this.setEnviarMens({ tipo: "E", mensaje: `${error.message}`, tiempo: null });
        }

        // Lanzar la excepción nuevamente para que otros controladores de errores superiores puedan manejarla si es necesario
        throw error;
      }
    },

    ///////////////// Evento ---> Editar //////////////////
    async getUserCredentialData() {

      let userCredentialResult = await axios.get(`/sistema/usuario/userCredential/${this.item.persona.id}`);

      this.perfilEdit = true;
      this.persona.usu_usuario = userCredentialResult.data[0].usu_usuario
      this.persona.fecha_fin = userCredentialResult.data[0].fecha_fin
      this.cargarLicenciaTipo(userCredentialResult.data[0].id_perfil)
      this.persona.id_perfil = userCredentialResult.data[0].id_perfil
      this.persona.serie_licencia = userCredentialResult.data[0].serie_licencia
      this.persona.id_licencia_tipo = userCredentialResult.data[0].id_tipo_licencia;
      this.persona.id_persona = userCredentialResult.data[0].id_persona

    },

    ////////////////////////// Fin de Registro de usuario //////////////////////////////////////

    async saveAvatar(idPersona, id_colegio, archivo) {
      try {
        let formData = new FormData();
        formData.append("subirArchivo", archivo);
        formData.append("id_colegio", id_colegio);
        formData.append("id_persona", idPersona);

        const resSaveAvatar = await axios.post("/archivo/avatarPersona",
          formData, {
          headers: { "Content-Type": "multipart/form-data" },
        }
        )
        return {
          tipo: resSaveAvatar.data.messageT,
          mensaje: resSaveAvatar.data.message
        }

        // S o E para indicar si funcionó el gf
      } catch (error) {
        return {
          tipo: "E",
          mensaje: `Se guardaron los datos correctamente menos la foto.`
          //Significa que ocurrió error al gurdar la foto
        }

      }
    },

    async save() {
      // Esta funcion sirve para editar una matricula y para registrar , es decir guardar y editar
      this.loading = true;
      try {
        if (!this.$refs.form_alumno_ubicacion.validate()) {
          // Si lo datos no se insertaron correctamente entonces no continuamos
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Debe llenar todos los campos requeridos.`,
            tiempo: null,
          });
          return
        }
        let dataRequest = {
          idColegio: this.idColegio,
          idUsuario: this.idUsuario,
          idAlumno: this.idAlumno,
          nombres: this.nombres,
          apellidoPaterno: this.apellidoPaterno,
          apellidoMaterno: this.apellidoMaterno,
          idTipoDocumento: this.idTipoDocumento,
          numeroDocumento: this.numeroDocumento,
          sexo: this.idSexo,
          fechaNacimiento: this.fechaNacimiento,
          idPaisNacimiento: this.idPaisNacimiento,
          idNacionalidad: this.idNacionalidad,
          idReligion: this.idTipoReligion,
          idDiscapacidad: this.idTipoDiscapacidad,
          observacionAlumno: this.observacionAlumno,
          idPais: this.idPais,
          idDepartamento: this.idDepartamento,
          idProvincia: this.idProvincia,
          idDistrito: this.idDistrito,
          direccion: this.direccion,
          celular: this.celular,
          telefono: this.telefono,
          observacionDomicilio: this.observacionDomicilio,
          correo: this.correo,
          viveCon: this.viveCon,
          viveConDescripcion: this.descripcionOtros,
          idNivel: this.idNivel,
          idGrado: this.idGrado,
          cod_estudiante: this.cod_estudiante,
          estado_alumno: this.estado_alumno,
        };

        ////////  CREAR USUARIOS REQUEST ////////////////

        this.persona.evento = this.evento;
        this.persona.nombre_persona = this.nombres;
        this.persona.id = this.idAlumno;//
        this.persona.ape1_persona = this.apellidoPaterno;
        this.persona.ape2_persona = this.apellidoMaterno;
        this.persona.id_tipo_documento = this.idTipoDocumento;
        this.persona.numdoc_persona = this.numeroDocumento;
        this.persona.correo_persona = this.correo;
        this.persona.id_ubicacion1 = this.idDepartamento;
        this.persona.id_ubicacion2 = this.idProvincia;
        this.persona.id_ubicacion3 = this.idDistrito;
        this.persona.direc_persona = this.direccion;
        this.persona.telf_persona = this.telefono;
        this.persona.cel_persona = this.celular;
        this.persona.sexo_persona = this.idSexo;
        this.persona.fecnac_persona = this.fechaNacimiento;
        this.persona.id_pais_nacimiento = this.idPaisNacimiento;
        this.persona.id_nacionalidad = this.idNacionalidad;
      
        if (this.evento == 'agregar') {
          let { data } = await axios.post("/sistema/usuario/", this.persona);

          if (data.success) {

            this.setEnviarMens({
              tipo: data.messageT,
              mensaje: data.message,
              tiempo: "null",
            });
          } else {
            this.setEnviarMens({
              tipo: data.messageT,
              mensaje: data.message,
              tiempo: "null",
            });
          }

          this.perfilEdit = false;

        }
        //Cuando se cree por primera vez (idAlumno = 0)
        if (dataRequest.idAlumno == 0) {
          console.log('Se crea el usuario por primera vez')
        } else {
          //En caso haya modificado los niveles y/o grados Y el estudiante se este editando
          if (this.nivel_before != this.idNivel || this.grado_before != this.idGrado) {
            this.modal_edit_nivel_grado = true;
            return
          }
        }

        let resRegistrarAlumno = await axios.post("/administrativo/alumno/registrarAlumno",
          dataRequest,
        );

        resRegistrarAlumno = resRegistrarAlumno.data;
        if (resRegistrarAlumno.messageT === "E") {
          // Si no se pudieron registrar los datos entonencesenviamos el mensaje y terminamos este proceso
          this.setEnviarMens({
            tipo: resRegistrarAlumno.messageT,
            mensaje: resRegistrarAlumno.message,
            tiempo: null,
          });
          return
        }

        // Si no hubo error la funcion continuará registrando la foto si existe
        if (!this.img) {
          // Si no se seleccionó img entoncesmostramos el mensaje,  refrescamos y terminamos el proceso
          this.setEnviarMens({
            tipo: resRegistrarAlumno.messageT,
            mensaje: resRegistrarAlumno.message,
            tiempo: null,
          });
          this.$router.push("/registroacademico");
          return
          // Refrescamos
        }
        else if (this.img) {
          // Si se seleccionó una img entonces la guardamos

          // Recibo el idPesona del alumno recien creado
          let idPersona = resRegistrarAlumno.idPersona
          // Intentamos registrar la foto
          const resSaveAvatar = await this.saveAvatar(idPersona, this.idColegio, this.img)

          // El mensaje se describe en la funcion
          // y refrescamos
          this.$router.push("/registroacademico");
          this.setEnviarMens(resSaveAvatar)
        }


      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Ups! no se pudo guardar, por favor intente de nuevo.`,
          tiempo: null,
        });
      } finally {
        this.loading = false;
      }
    },

    //Función que disparara un stored procedure que eliminara la informacion que vincula al estudiante con la sección
    async editarEstudianteNivelGrado() {
      let dataRequest = {
        idColegio: this.idColegio,
        idUsuario: this.idUsuario,
        idAlumno: this.idAlumno,
        nombres: this.nombres,
        apellidoPaterno: this.apellidoPaterno,
        apellidoMaterno: this.apellidoMaterno,
        idTipoDocumento: this.idTipoDocumento,
        numeroDocumento: this.numeroDocumento,
        sexo: this.idSexo,
        fechaNacimiento: this.fechaNacimiento,
        idPaisNacimiento: this.idPaisNacimiento,
        idNacionalidad: this.idNacionalidad,
        idReligion: this.idTipoReligion,
        idDiscapacidad: this.idTipoDiscapacidad,
        observacionAlumno: this.observacionAlumno,
        idPais: this.idPais,
        idDepartamento: this.idDepartamento,
        idProvincia: this.idProvincia,
        idDistrito: this.idDistrito,
        direccion: this.direccion,
        celular: this.celular,
        telefono: this.telefono,
        observacionDomicilio: this.observacionDomicilio,
        correo: this.correo,
        viveCon: this.viveCon,
        viveConDescripcion: this.descripcionOtros,
        idNivel: this.idNivel,
        idGrado: this.idGrado,
        cod_estudiante: this.cod_estudiante
      };
      console.log(dataRequest)
      let id_ano_lectivo = Number(this.nivelParams.id_ano_lectivo)

      await axios.post(`/administrativo/alumno/deleteInformationStudent/`, {
        "id_ano_lectivo": id_ano_lectivo,
        "id_alumno": dataRequest.idAlumno
      })

      let resRegistrarAlumno = await axios.post("/administrativo/alumno/registrarAlumno",
        dataRequest,
      );
      resRegistrarAlumno = resRegistrarAlumno.data;

      if (resRegistrarAlumno.messageT === "E") {
        this.setEnviarMens({
          tipo: resRegistrarAlumno.messageT,
          mensaje: resRegistrarAlumno.message,
          tiempo: null,
        });
        return
      }

      if (!this.img) {
        // Si no se seleccionó img entoncesmostramos el mensaje,  refrescamos y terminamos el proceso
        this.setEnviarMens({
          tipo: resRegistrarAlumno.messageT,
          mensaje: resRegistrarAlumno.message,
          tiempo: null,
        });
        this.$router.push("/registroacademico");
        return
      } else if (this.img) {
        // Si se seleccionó una img entonces la guardamos
        // Recibo el idPesona del alumno recien creado
        let idPersona = resRegistrarAlumno.idPersona
        // Intentamos registrar la foto
        const resSaveAvatar = await this.saveAvatar(idPersona, this.idColegio, this.img)

        // El mensaje se describe en la funcion
        // y refrescamos
        this.$router.push("/registroacademico");
        this.setEnviarMens(resSaveAvatar)
      }
    },

    moment() {
      return moment();
    },

    async get_avatar() {
      if (!this.avatar_persona) return null;
      const urlAvatar = `${this.URL_SPACE}/${this.ruta_avatar_persona}`
      this.previewAvatar = urlAvatar
    },

    async getAllNivelesAdmin() {
      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          this.nivelParams
        );
        this.listNivelesAdmin = response.data;
        this.getAllGradosAdmin();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getAllGradosAdmin() {
      const index = this.listNivelesAdmin.findIndex(
        (nivel) => nivel.id == this.idNivel
      );
      if (index > -1) {
        let nivel = this.listNivelesAdmin[index];
        let params = {
          id_usuario: sessionStorage.id,
          id_nivel: nivel.id_nivel_adm_nivel,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
        };
        try {
          let response = await axios.post(
            "/administrativo/grado/gradosNivelAdmin/",
            params
          );
          this.listGradosAdmin = response.data;
          if (this.listGradosAdmin.length === 0) {
            this.setEnviarMens({
              tipo: "W",
              mensaje: "Aún no hay Grados registrados en este Nivel",
              tiempo: null,
            });
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    pickAvatar() {
      this.$refs.imageCol.click();
    },

    onFileAvatar(e) {
      const file = e.target.files[0];
      if (file) {
        this.img = (file);
        this.srcImg = URL.createObjectURL(file);

      }
    },


  },

  computed: {
    validationRules() {
      return validationRules;
    },


    avatarImg() { //Esta fn() al momento de guardar al SPACE en lugar del droplet, quedo obsoleta (ELIMINAR DESPUES DE VERIFICAR QUE NO SE USA)
      if (this.ruta_avatar_persona) {
        return this.rutaServer + this.ruta_avatar_persona + this.avatar_persona;
      } else {
        return null;
      }
    },
  },
};
</script>
<style>
.tabs {
  width: 100%;
  height: 60;
  padding: 10px;
  display: flex;
  align-items: center;
}

.circle {
  width: 40px;
  height: 40px;
  background: #caccd1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  margin: 0 10px 0;
}

.circle_active {
  background: #0277bd;
}

.titulo {
  margin: 0 10px 0 0;
}

.separador {
  width: 60px;
  border: 1px solid #caccd1;
  background: #caccd1;
}

.btn_actions {
  margin: 10px 0;
}

.fondo_add_img {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  cursor: pointer;
  cursor: hand;
  border: 4px solid #fff;
  color: #524f4f;
  border-color: #474545;
}

.fondo_add_img:hover {
  border-color: #b3b3b3;
  color: #b3b3b3;
}
</style>
